import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 用户的付款管理
 */
class State extends UltMeta {
    OVERDUE = new Meta(1, "逾期");
    NORMAL = new Meta(2, "正常");
    SETTLE = new Meta(3, "结清");
}

export const LOAN_RECEIPT_STATE = new State();
